import { schema } from 'normalizr'

export const languagePairSchema = new schema.Entity('languagePairs');
export const customerSchema = new schema.Entity('customers');
export const userSchema = new schema.Entity('users');
export const orderSchema = new schema.Entity('orders');
export const projectSchema = new schema.Entity('project');
export const supplierConfigurationSchema = new schema.Entity('supplierConfiguration');

export const languagePairListSchema = new schema.Array(languagePairSchema);
export const customerListSchema = new schema.Array(customerSchema);
export const userListSchema = new schema.Array(userSchema);
export const orderListSchema = new schema.Array(orderSchema);
export const projectListSchema = new schema.Array(projectSchema);

export const supplierConfigurationListSchema = new schema.Array(supplierConfigurationSchema);


orderSchema.define({
	langPair: languagePairSchema,
	user: userSchema,
	phase: [{
		user: userSchema,
	}]
})

userSchema.define({
	customer: customerSchema
//	curriculum: {
//		languages: languagePairListSchema,
//		nativeLanguages: languagePairListSchema
//	}
})

supplierConfigurationSchema.define({
	supplier: userSchema,
	customerUser: userSchema
})

customerSchema.define({
	product: [{
		langPair: languagePairSchema,
		suppliers: supplierConfigurationListSchema
	}]
})

projectSchema.define({
	orders: orderListSchema
})
